import { createFileRoute } from '@tanstack/react-router'
import MarketingAutomacoesExecucoesPage from '@/pages/dashboard/marketing-automacoes-execucoes-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/automacoes/$automacaoId/execucoes',
)({
  component: function MarketingAutomacoesExecucoesRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.AUTOMACOES} dashboardId={dashboardId}>
        <MarketingAutomacoesExecucoesPage />
      </RequireModule>
    )
  },
})
